import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

export const MapLocationEditor = ({ location, onClose, onSave }) => {
  const [lng, lat] = location?.coordinates || ["", ""];
  const [form, setForm] = useState({ latitude: lat, longitude: lng });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function save(event) {
    event.preventDefault(); setBusy(true); setError("");
    try { await onSave({ latitude: Number(form.latitude), longitude: Number(form.longitude) }); onClose(); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent className="practice-map-coordinate-dialog" data-testid="practice-map-coordinate-dialog" closeTestId="practice-map-coordinate-close">
      <DialogHeader><DialogTitle>Posizione dell’intervento</DialogTitle><DialogDescription>Coordinate geografiche WGS84</DialogDescription></DialogHeader>
      <form onSubmit={save} data-testid="practice-map-coordinate-form">
        <div className="practice-form-grid">
          <label>Latitudine<input required type="number" min="-90" max="90" step="any" data-testid="practice-map-latitude" disabled={busy} value={form.latitude} onChange={e => setForm({ ...form, latitude: e.target.value })} /></label>
          <label>Longitudine<input required type="number" min="-180" max="180" step="any" data-testid="practice-map-longitude" disabled={busy} value={form.longitude} onChange={e => setForm({ ...form, longitude: e.target.value })} /></label>
        </div>
        {error && <p className="error" role="alert" data-testid="practice-map-coordinate-error">{error}</p>}
        <div className="practice-map-actions">
          <button type="button" className="ghost" disabled={busy} data-testid="practice-map-coordinate-cancel" onClick={onClose}>Annulla</button>
          <button type="submit" className="primary" disabled={busy} data-testid="practice-map-coordinate-save">{busy ? "Salvataggio…" : "Salva posizione"}</button>
        </div>
      </form>
    </DialogContent>
  </Dialog>;
};